<template>
  <div id="viewer">
    <img v-for="src in list" :key="src" style="height: 1px; opacity: 0" :src="src" />
  </div>
</template>
<script>
import { watch, nextTick } from "vue";
import Viewer from "viewerjs";
import { useVModel } from "@vueuse/core";
export default {
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const list = useVModel(props, "images", emit);

    let viewer = null;

    // const myClose = () => {
    //   imgs.value.pop();
    //   viewer?.destroy();

    //   nextTick(init);
    // };

    const options = Object.assign(
      {
        backdrop: false,
        inline: true,
        button: false,
        toolbar: {
          prev: true,
          rotateLeft: true,
          zoomIn: true,
          zoomOut: true,
          rotateRight: true,
          next: true,
          // myClose,
        },
      },
      props.options
    );

    const init = () => {
      nextTick(() => {
        // 解决弹窗抖动问题
        setTimeout(() => {
          if (!viewer) {
            viewer = new Viewer(document.getElementById("viewer"), options);
          } else {
            viewer.update();
          }
        }, 300);
      });
    };

    watch(() => list.value, init, {
      immediate: true,
    });

    return { list };
  },
};
</script>
